export class SortModel {
  sortBy: string;
  direction: string;
}
